import DropdownAddressItem from '~/src/components/common-components/dropdown-address-item/dropdown-address-item';
import type {
    PrepareDataType,
} from '~/src/components/blocks/clients-request/organization-info/organization-info.types';
import type {
    AddressSuggestionProps,
} from '~/src/components/common-components/dropdown-address-item/dropdown-address-item.types';
import type {
    AddressFields,
    GetAddressValidationErrorType,
} from '~/src/components/common-components/address-field/address-field.types';

export const prepareDataFromDropdownAddress: PrepareDataType<AddressSuggestionProps> = ({ data = [], callback }) => {
    return data.map((item) => ({
        id: item?.fullName || item?.region,
        value: item?.fullName,
        houseFiasId: item?.houseFiasId,
        Component: callback(data),
    }));
};

export const getAddressComponentItem = (data: AddressSuggestionProps[] | []): JSX.Element[] => {
    return (
        data.map((elem, key) => (
            <DropdownAddressItem key={elem?.region + String(key)} {...elem}/>
        ))
    );
};

/**
 * Used in Module Federation
 */
export const getAddressValidationError: GetAddressValidationErrorType = (
    suggestedAddress,
    requiredFields,
    baseTextError = 'Должен содержать:',
) => {
    const textErrorAddressFieldMap: AddressFields = {
        block: 'строение',
        city: 'город',
        country: 'страну',
        flat: 'квартиру',
        house: 'дом',
        postcode: 'индекс',
        region: 'регион',
        street: 'улицу',
    };
    const errorAddressArray: string[] = [];

    for (const field of requiredFields) {
        if (!suggestedAddress[field]) {
            errorAddressArray.push(textErrorAddressFieldMap[field]);
        }
    }

    if (errorAddressArray.length) {
        return baseTextError + ' ' + errorAddressArray.join(', ');
    }

    return '';
};

export default getAddressValidationError;